<template>
    <prime-file-upload
        mode="basic"
        name="attachment"
        custom-upload
        :accept="accept"
        :max-file-size="maxFileSize"
        :auto="true"
        @uploader="$emit('file', $event.files[0])"
    />
</template>

<script setup lang="ts">
import PrimeFileUpload from 'primevue/fileupload'

defineEmits<{
    (e: 'file', payload: File): true
}>()

const maxFileSize = 4 * 1024 * 1024
const accept =
    'image/png,image/jpg,image/jpeg,application/pdf,application/x-pdf'
</script>
